export function getOidcBaseUrl(pathname: string): string {
  const pathSegments = pathname.split('/').filter(Boolean);

  if (pathSegments[0] === 'industriminne') {
    return pathSegments[1] === 'en' ? '/industriminne/en/' : '/industriminne/';
  }

  return pathSegments[0] === 'en' ? '/en/' : '/';
}
